<template>
  <div>
    <div class="tw-bg-[#031b41] tw-rounded-xl sm:tw-mb-5">
      <div class="tw-text-white tw-pb-3 tw-pt-5 tw-px-5 tw-text-left tw-font-semibold tw-text-sm">
        Providers ({{ providers.length }})
      </div>
      <v-divider class="tw-border-white"></v-divider>
      <div class="text-left tw-p-5 tw-text-white tw-flex tw-justify-center tw-items-center tw-space-x-3">
        <div v-if="$auth.user && $auth.user.type == 'admin'">
          <draggable v-model="providers" @change="onChange">
            <transition-group class="tw-flex tw-flex-wrap md:tw-grid md:tw-grid-cols-2 tw-gap-3">
              <button
                v-for="provider in showProviders"
                :key="provider"
                :class="`md:tw-w-[140px] tw-flex tw-justify-center tw-items-center tw-p-2 tw-rounded-md  tw-text-sm ${
                  checkIfSelected(provider) ? 'tw-bg-[#2b57fb]' : 'tw-bg-[#0a356b]'
                }`"
                @click="selectProvider(provider)"
              >
                <div
                  class="tw-w-full tw-h-full"
                  :style="{
                    backgroundImage: `url('${prodENV ? '/casino-games' : ''}/assets/images/providers/${provider}.png')`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                  }"
                >
                  &nbsp;
                </div>
              </button>
            </transition-group>
          </draggable>
          <div v-if="providers.length >= showLimit" class="tw-flex tw-justify-center tw-col-span-2 tw-mt-5">
            <button
              v-if="providers.length > showLimit"
              class="tw-flex tw-justify-center tw-font-bold tw-text-xs"
              @click="showMoreProviders"
            >
              <span class="tw-italic tw-underline">See More</span>
              <v-icon small class="tw-ml-1">mdi-chevron-down</v-icon>
            </button>
            <button v-else class="tw-flex tw-justify-center tw-font-bold tw-text-xs" @click="showLessProviders">
              <span class="tw-italic tw-underline">Show Less</span>
              <v-icon small class="tw-ml-1">mdi-chevron-up</v-icon>
            </button>
          </div>
        </div>
        <div v-else class="tw-grid tw-grid-cols-4 md:tw-grid-cols-2 tw-gap-3">
          <button
            v-for="provider in showProviders"
            :key="provider"
            :class="`tw-w-[80px] md:tw-w-[140px] tw-flex tw-justify-center tw-items-center tw-p-2 tw-rounded-md  tw-text-sm ${
              checkIfSelected(provider) ? 'tw-bg-[#2b57fb]' : 'tw-bg-[#0a356b]'
            }`"
            @click="selectProvider(provider)"
          >
            <div
              class="tw-w-full tw-h-full"
              :style="{
                backgroundImage: `url('${prodENV ? '/casino-games' : ''}/assets/images/providers/${provider}.png')`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
              }"
            >
              &nbsp;
            </div>
          </button>
          <div
            v-if="providers.length >= showLimit"
            class="tw-col-span-4 md:tw-col-span-2 tw-w-full tw-flex tw-justify-center"
          >
            <div>
              <button
                v-if="providers.length > showLimit"
                class="tw-flex tw-justify-center tw-font-bold tw-text-xs"
                @click="showMoreProviders"
              >
                <span class="tw-italic tw-underline">See More</span>
                <v-icon small class="tw-ml-1">mdi-chevron-down</v-icon>
              </button>
              <button v-else class="tw-flex tw-justify-center tw-font-bold tw-text-xs" @click="showLessProviders">
                <span class="tw-italic tw-underline">Show Less</span>
                <v-icon small class="tw-ml-1">mdi-chevron-up</v-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import draggable from "vuedraggable";
export default {
  props: ["type"],
  components: {
    draggable,
  },
  data: () => ({
    selected_providers: [],
    providers: [],
    showLimit: 8,
    isAtBottom: false,
  }),

  async mounted() {
    await this.getProviders();
    this.assignProviderInQuery();
  },
  watch: {
    "$route.query.providers": {
      handler() {
        if (!this.$route.query.providers) {
          this.selected_providers = [];
          return;
        }
        this.selected_providers = this.$route.query.providers.split(",");
      },
    },
  },

  computed: {
    prodENV() {
      return process.env.VUE_APP_SERVER_ENV == "prod";
    },
    getFilters() {
      switch (this.$route.name) {
        case "Slots":
          return "slots";
        case "LiveCasino":
          return "live";
        case "Home":
          return ["slots", "live"];
        default:
          return ["slots", "live"];
      }
    },
    showProviders() {
      return this.providers.slice(0, this.showLimit);
    },
  },
  methods: {
    ...mapActions("game", ["filterProviders", "saveProviderOrder"]),

    showMoreProviders() {
      this.showLimit += 8;
      if (this.showLimit > this.providers.length) {
        this.showLimit = this.providers.length;
      }
    },
    showLessProviders() {
      this.showLimit = 8;
    },

    async getProviders() {
      const payload = {
        game_type: this.getFilters,
        isMobile: this.$device.mobile,
      };
      const data = await this.filterProviders(payload);
      this.providers = data.map((d) => d.provider);
    },
    async assignProviderInQuery() {
      const providers = this.$route.query.providers || "";

      providers.split(",").map((provider) => {
        this.selected_providers.push(provider);
      });
      this.selected_providers = this.selected_providers.filter((provider) => !!provider);
    },
    async selectProvider(provider) {
      if (this.selected_providers.includes(provider)) {
        this.selected_providers = this.selected_providers.filter((selected_provider) => selected_provider != provider);
      } else {
        this.selected_providers.push(provider);
      }

      this.selected_providers = this.selected_providers.filter((provider) => !!provider);

      const query = {
        ...this.$route.query,
        providers: this.selected_providers.join(","),
      };
      if (this.selected_providers.length == 0) {
        delete query.providers;
      }
      this.$router.replace({
        query,
      });
      this.$emit("providers", this.selected_providers);
    },

    checkIfSelected(provider) {
      const selected = this.selected_providers.find(
        (selected_provider) => selected_provider.toLowerCase() == provider.toLowerCase()
      );
      return !!selected;
    },

    async onChange(e) {
      const { element, newIndex, oldIndex } = e.moved;
      const response = await this.saveProviderOrder({
        providers: this.providers,
        element,
        newIndex,
        oldIndex,
        game_type: this.getFilters,
      });
    },
  },
};
</script>

<style></style>
